import { NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap';

export const provideBootstrapConfig = () => {
  return {
    provide: NgbTooltipConfig,
    useFactory: () => {
      const config = new NgbTooltipConfig();
      config.triggers = 'hover'; 
      config.container = 'body';
      return config;
    }
  };
};